import { EnrichmentTypeEnum } from '@aibees/elephant/types';
import {
  CreditUsageType,
  EnrichmentOptionTypeEnum,
  EnrichOption,
  EnrichOptionsType,
} from '@aibees/shared/definition';
import { Typography } from '@mui/material';

const EmailEnrichOptions: EnrichOption[] = [
  {
    title: 'Email Finder',
    type: EnrichmentOptionTypeEnum.CONTACT_REVEAL_EMAIL,
    icon: 'email-outline',
    description: 'Ad Hoc Data',
    creditUsage: 1,
    creditCostType: CreditUsageType.CONTACT_EMAIL_FINDING,
    active: false,
    gridSize: 4,
  },
];

const EmailFinderEnrichOptions: EnrichOption[] = [
  {
    title: 'Email Finder',
    type: EnrichmentOptionTypeEnum.CONTACT_REVEAL_EMAIL,
    icon: 'email-outline',
    description: 'Ad Hoc Data',
    creditUsage: 1,
    creditCostType: CreditUsageType.CONTACT_EMAIL_FINDING,
    active: false,
    gridSize: 4,
  },
];

const EmailVerifierEnrichOptions: EnrichOption[] = [
  {
    title: 'Email Verifier',
    type: EnrichmentOptionTypeEnum.CONTACT_REVEAL_EMAIL,
    icon: 'email-outline',
    description: 'Ad Hoc Data',
    creditUsage: 1,
    creditCostType: CreditUsageType.CONTACT_EMAIL_FINDING,
    active: false,
    gridSize: 4,
  },
];
const CompanyEnrichOptions: EnrichOption[] = [
  {
    title: 'Company Detail Enrichment',
    description: 'Up to 30 Days Old Data',
    icon: 'business',
    creditUsage: 0.5,
    creditCostType: CreditUsageType.ACCOUNT_STORAGE_ENRICH,
    isMandatory: true,
    active: true,
    gridSize: 12,
    tooltip: (credit) => (
      <Typography variant="body5" component="span">
        This option allows you to get the most up-to-date detailed information
        from company profiles. The maximum credit cost is{' '}
        <Typography variant="body5" component="span" fontWeight={700}>
          {credit} credits
        </Typography>{' '}
        per profile. Please note that the actual cost may vary depending on data
        availability, failed attempts, not found data, and duplicates. Any
        unused credits will be refunded after enrichment.
      </Typography>
    ),
    type: EnrichmentOptionTypeEnum.CONTACT_REVEAL_PROFILE,
  },
];

const PeopleEnrichOptions: EnrichOption[] = [
  {
    title: 'Basic Storage for Matched Contacts',
    type: EnrichmentOptionTypeEnum.CONTACT_STORAGE_BASIC,
    icon: 'email-outline',
    description: 'Up to 30 Days Old Data',
    creditUsage: 0.5,
    creditCostType: CreditUsageType.CONTACT_STORAGE_ENRICH,
    active: true,
    isMandatory: true,
    gridSize: 12,
    tooltip: (credit) => (
      <Typography variant="body5" component="span">
        This option allows you to get the basic most up-to-date information from
        people profiles. A charge of{' '}
        <Typography variant="body5" component="span" fontWeight={700}>
          {credit} credits
        </Typography>{' '}
        applies for any matched record, regardless of whether that contact has
        been previously stored or not. Please note that the actual cost may vary
        depending on data availability, failed attempts, not found data, and
        duplicates. Any unused credits will be refunded after enrichment.
      </Typography>
    ),
  },
  {
    title: 'Email Finder',
    type: EnrichmentOptionTypeEnum.CONTACT_REVEAL_EMAIL,
    icon: 'email-outline',
    description: 'Ad Hoc Data',
    creditUsage: 0.5,
    creditCostType: CreditUsageType.CONTACT_EMAIL_FINDING,
    active: false,
    gridSize: 6,
    tooltip: (credit) => (
      <Typography variant="body5" component="span">
        Choose this option to get the most up-to-date email addresses. Charges
        of up to{' '}
        <Typography variant="body5" component="span" fontWeight={700}>
          {credit} credits
        </Typography>{' '}
        are applied for each valid email found, whether the contact is newly
        added or already stored. No charges apply if a valid email cannot be
        found. Any unused credits will be refunded after enrichment.
      </Typography>
    ),
  },
  {
    title: 'Contact Detail Enrichment',
    type: EnrichmentOptionTypeEnum.CONTACT_REVEAL_PROFILE,
    description: 'Up to 30 Days Old Data',
    icon: 'phone',
    creditUsage: 0.5,
    creditCostType: CreditUsageType.CONTACT_PROFILE_REVEAL,
    active: false,
    gridSize: 6,
    tooltip: (credit) => (
      <Typography variant="body5" component="span">
        Choose this option to get the most up-to-date advanced detailed
        information from people profiles. Charge of up to{' '}
        <Typography variant="body5" component="span" fontWeight={700}>
          {credit} credits
        </Typography>{' '}
        applies for each enriched profile, regardless of whether the contact has
        been previously stored or not. Please note that the actual cost may vary
        depending on data availability, failed attempts, not-found results, and
        duplicates. Any unused credits will be refunded after enrichment.
      </Typography>
    ),
  },
  {
    title: 'Mobile Phone Number',
    type: EnrichmentOptionTypeEnum.CONTACT_REVEAL_PHONE_CACHED,
    description: 'Ad Hoc Data',
    icon: 'person-search-outline',
    creditUsage: 5,
    creditCostType: CreditUsageType.CONTACT_PHONE_FINDING,
    active: false,
    gridSize: 6,
    tooltip: (credit) => (
      <Typography variant="body5" component="span">
        Choose this option to get the most up-to-date phone numbers for your
        contacts. A charge of up to{' '}
        <Typography variant="body5" component="span" fontWeight={700}>
          {credit} credits
        </Typography>{' '}
        applies for each valid Mobile phone number found, regardless of whether
        the contact has been previously stored or not. Please note that the
        actual cost may vary depending on data availability, failed attempts,
        not-found results, and duplicates. Any unused credits will be refunded
        after enrichment.
      </Typography>
    ),
  },
  {
    title: 'AI Personality',
    type: EnrichmentOptionTypeEnum.CONTACT_REVEAL_ANALYSIS,
    description: 'Up to 30 Days Old Data',
    icon: 'person-search-outline',
    creditUsage: 4,
    creditCostType: CreditUsageType.CONTACT_ANALYSIS_REVEAL,
    active: false,
    gridSize: 6,
    tooltip: (credit) => (
      <Typography variant="body5" component="span">
        Choose this option to get the most up-to-date AI analysis of people
        profiles. A charge of up to{' '}
        <Typography variant="body5" component="span" fontWeight={700}>
          {credit} credits
        </Typography>{' '}
        applies for each analyzed profile, regardless of whether the contact has
        been previously stored or not. Please note that the actual cost may vary
        depending on data availability, failed attempts, not-found results, and
        duplicates. Any unused credits will be refunded after enrichment.
      </Typography>
    ),
  },
];

export const options: EnrichOptionsType = {
  [EnrichmentTypeEnum.COMPANY]: CompanyEnrichOptions,
  [EnrichmentTypeEnum.EMAIL]: EmailEnrichOptions,
  [EnrichmentTypeEnum.EMAIL_FINDER]: EmailFinderEnrichOptions,
  [EnrichmentTypeEnum.EMAIL_VERIFIER]: EmailVerifierEnrichOptions,
  [EnrichmentTypeEnum.PERSON]: PeopleEnrichOptions,
};
